export const TENANT_CONFIG = {
  galicia: {
    label: "Galicia Pilot",
    routes: ["live-incidents", "n550-map"],
  },
  riga: {
    label: "Riga Pilot",
    routes: ["live-incidents"],
  },
};
